import React from 'react'
import { number, string, bool } from 'prop-types'
import { Card, Row, Image, Bleed, MarginBox, H2, Ellipsis, Paragraph, Separator } from '@fs/zion-ui'
import StoryPreviewImages from '../StoryPreviewImages'

const Bleeder = ({ doBleed, children }) => {
  if (doBleed) {
    return <Bleed all>{children}</Bleed>
  }
  return children
}

export default function StoryThumbnailCard({
  doBleed,
  headerImage,
  imageWidth,
  imageHeight,
  title,
  firstAnswerBody,
  activityGroupImageUrl,
  userImageUrl,
  showPreviewImages = false,
}) {
  return (
    <Card maxWidth={imageWidth}>
      <Bleeder doBleed={doBleed}>
        {showPreviewImages && activityGroupImageUrl && (
          <>
            <Row alignX="center">
              <StoryPreviewImages activityGroupImageUrl={activityGroupImageUrl} userImageUrl={userImageUrl} />
            </Row>
            <Separator size="xs" />
          </>
        )}
        <Row alignX="center">
          <Image src={headerImage} maxHeight={imageHeight} maxWidth={imageWidth} alt="" />
        </Row>
        <MarginBox marginX="xs" marginY="xs">
          <H2 size="H6">
            <Ellipsis lineClamp={2}>{title}</Ellipsis>
          </H2>
          <Paragraph size="sm">
            <Ellipsis lineClamp={2}>{firstAnswerBody}</Ellipsis>
          </Paragraph>
        </MarginBox>
      </Bleeder>
    </Card>
  )
}

StoryThumbnailCard.propTypes = {
  headerImage: string.isRequired,
  imageWidth: number.isRequired,
  imageHeight: number.isRequired,
  title: string.isRequired,
  firstAnswerBody: string,
  activityGroupImageUrl: string,
  userImageUrl: string,
  showPreviewImages: bool,
}
